import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  CardHeader,
  Col,
  Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

interface ButtonType {
  label: string;
  onClick: () => void;
  color?: string;
  disable?: boolean;
  textColor?: string;
}

interface PageHeaderProps {
  title: string;
  buttons?: ButtonType[];
  BreadCrumb?: boolean;
  RightButtonContent?: React.ReactNode;
  ExtraButton?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  buttons = [],
  BreadCrumb = true,
  RightButtonContent,
  ExtraButton,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract path segments
  const pathSegments = location.pathname.split("/").filter((x) => x);

  // Get the module name dynamically (first path segment)
  const moduleName =
    pathSegments.length > 0
      ? pathSegments[0]
          .replace(/-/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase())
      : "Dashboard"; // Default fallback if no module exists

  // Generate breadcrumbs for subpaths
  const generateBreadcrumbs = () => {
    return pathSegments.slice(1).map((name, index) => {
      const pathTo = `/${pathSegments.slice(0, index + 2).join("/")}`;
      return {
        label: name.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()), // Format dynamically
        path: pathTo,
        active: index === pathSegments.length - 2,
      };
    });
  };

  return (
    <Col sm="12">
      <Card className="border-0">
        {/* <Card className="border-0" style={{marginBottom:0}}> */}
        <CardHeader className="pb-3 border-0">
          <Row className="align-items-center justify-content-between w-100">
            {/* Left: Title */}
            <Col md="4" className="d-flex align-items-center gap-2">
              <div
                style={{
                  backgroundColor: "#E6F3F3",
                  padding: "6px",
                  borderRadius: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => navigate(-1)}
              >
                <FaArrowLeft size={20} color="#4BBCB5" />
              </div>

              <h4 className="mb-0">{title}</h4>
            </Col>

            {/* Right: Buttons + Breadcrumb */}
            <Col
              md="8"
              className="d-flex justify-content-end align-items-center flex-wrap gap-3"
            >
              {/* Buttons */}
              {!ExtraButton ? (
                buttons.map((button, index) => (
                  <Button
                    key={index}
                    style={{
                      borderRadius: "50px",
                      backgroundColor: button.color || "#007bff",
                      borderColor: button.color || "#007bff",
                      color: button.textColor || "#ffffff",
                    }}
                    onClick={button.onClick}
                    size="sm"
                    disabled={button?.disable}
                  >
                    {button.label}
                  </Button>
                ))
              ) : (
                <>{RightButtonContent}</>
              )}

              {/* Dynamic Breadcrumb */}
              {/* {BreadCrumb && (
                <Breadcrumb className="mb-0">
                  <BreadcrumbItem style={{ color: "#4BBCB5" }}>
                    {" "}
                    
                    {moduleName}
                  </BreadcrumbItem>
                  {generateBreadcrumbs().map((item, index) => (
                    <BreadcrumbItem key={index} active={item.active}>
                      {item.path ? (
                        <Link to={item.path}>{item.label}</Link>
                      ) : (
                        item.label
                      )}
                    </BreadcrumbItem>
                  ))}
                </Breadcrumb>
              )} */}
            </Col>
          </Row>
        </CardHeader>
      </Card>
    </Col>
  );
};

export default PageHeader;
